var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.78221 0.206475C8.07264 0.486031 8.07259 0.942722 7.78209 1.22221L3.03067 5.79364C2.89244 5.92664 2.70655 6.00004 2.51428 6C2.32201 5.99996 2.13616 5.92649 1.99798 5.79343L0.217687 4.07914C-0.0726903 3.79953 -0.0725403 3.34284 0.218005 3.06341C0.504083 2.78827 0.964687 2.7884 1.2506 3.06371L2.51465 4.2809L6.74962 0.206361C7.03565 -0.0688305 7.49625 -0.0687815 7.78221 0.206475Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchCheck);
export default __webpack_public_path__ + "static/media/SwitchCheck.130c4d02748f941ea36af2c949c4a2dc.svg";
export { ForwardRef as ReactComponent };